import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const checkPostcode = (code) => axios.get(`${API}/postcode/${encodeURIComponent(code)}`).then((r) => r.data);
export const createLead = (payload) => axios.post(`${API}/leads`, payload).then((r) => r.data);
export const createBooking = (payload) => axios.post(`${API}/bookings`, payload).then((r) => r.data);
export const adminList = (kind, key) =>
  axios.get(`${API}/admin/${kind}`, { headers: { "X-Admin-Key": key } }).then((r) => r.data);
